export const ASSET_ROUTE: string = 'asset';
export const BASE_ROUTE: string = '/';
export const CHAIN_ROUTE: string = 'chain';
export const SEARCH_ROUTE: string = 'search';
